// Provides backwards compatibility for momentjs.
define(['moment'], function (moment) {
  'use strict';

  window.moment = moment;

  return moment;
});
